<nb-layout>
  <nb-layout-header >
    <ngx-loan-application-header></ngx-loan-application-header>
  </nb-layout-header>
  <nb-layout-column style="padding : 0" >
    <router-outlet></router-outlet>
  </nb-layout-column>
  <nb-layout-footer>
    <div class="row " >
      <div class="col-12 col-md-8 col-lg-8 mx-auto text-center">
    <ngx-loan-application-footer></ngx-loan-application-footer>
      </div>
    </div>
  </nb-layout-footer>
</nb-layout>

